import { render, staticRenderFns } from "./PartyRolePart.vue?vue&type=template&id=cfbd6e8a&scoped=true&"
import script from "./PartyRolePart.vue?vue&type=script&lang=js&"
export * from "./PartyRolePart.vue?vue&type=script&lang=js&"
import style0 from "./PartyRolePart.vue?vue&type=style&index=0&id=cfbd6e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbd6e8a",
  null
  
)

export default component.exports